import { WorkerAction, WorkerActionError, WorkerFnParams } from '../wasm-git.worker.model';
import { FSAction } from './actions.enum';

export interface FSWriteFileAction extends WorkerAction {
  type: FSAction.WriteFile;
  params: { path: string; content?: string; skipSync?: boolean };
}

class FSWriteFileActionError extends WorkerActionError {}

export async function FSWriteFileActionFn({ fs, params, util }: WorkerFnParams<FSWriteFileAction>): Promise<void> {
  const { path, skipSync } = params;

  // Throw errors for consecutive slashes in path
  // indicating a developer's mistake
  if (/(\/)\1+/.test(path)) {
    throw new FSWriteFileActionError(`Duplicate consecutive slashes found in path "${path}"`);
  }

  try {
    util.mkdirP(util.dirname(path));

    let { content } = params;

    if (!content) {
      content = '';
    }

    // make sure that saved file always contain a new line at the end of file
    if (!content.endsWith('\n')) {
      content += '\n';
    }
    console.debug(`[WasmGit]: writing file at "${path}"`);
    fs.writeFile(path, content);

    if (!skipSync) {
      await util.syncfs(false);
    }
  } catch (err) {
    throw new FSWriteFileActionError(err);
  }
}
